<template>
  
  <div class="content-wrap">
          <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="리비전번호">
              <template #end>
                <ElSelect v-model="state.revSelect.selected" :options="state.revidList.map(item => ({text: item.rev_id, value: item.rev_id}))"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
    </div>
    <div class="search-detail-wrap"></div>
    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getList()">
        검색
      </ElButton>
    </div>
    <div class="table-responsive table-list">

      <TreeTable ref="treeTableRef" :data-list="state.originList" :grid-column="state.gridColumn" :editable="true"
        :root-val="''" :useCheckBox="true" @editCol="r => editCell(r)" @editComplete="r => onCellEditComplete(r)" />
    </div>

    <div class="text-end py-3">
      <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
      <ElButton type="primary" @buttonClick="addRow()">추가</ElButton>
      <ElButton type="primary" @buttonClick="deleteRow()">삭제</ElButton>
      <ElButton type="primary" @buttonClick="updateProd()">저장</ElButton>
      <ElButton type="primary" @buttonClick="save()">버전업</ElButton>
    </div>

    <!-- 모달 -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >

    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, ref } from "vue";
import routerCmn from "@/js/vueRouterCmn";

import TreeTable from "@/components/common/TreeTable.vue";

import common from '@/js/common';
import { useUserStore } from '@/store/user'
const userStore = useUserStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { prodList, prodEdit, prodDelete, getProdRevIdList,prodRevClassInst } from "@/api/prod";

const treeTableRef = ref()


onMounted(async () => {
  await getRevList();

  await getList();
});
const state = reactive({
  selectedKey: [],
  gridColumn: [
    {
      header: "상품명",
      field: "class_nm",
      expander: true,
      style: { width : '14%' },
      type: 'text'
    },
    { header: "활성화 여부", field: "enable_yn", type: 'select', cdGr: 'YN_CD', chkEss: 'Y', style: { width : '8%' }, bodyClass: 'text-center'},
    { header: "계약만료 필수입력대상", field: "applicable_yn", type: 'select', cdGr: 'YNA_CD', chkEss: 'Y', style: { width : '13%' }, bodyClass: 'text-center'},
    { header: "GPU 여부", field: "gpu_model_yn", type: 'select',cdGr: 'YN_CD', chkEss: 'N',style: { width : '7%' },bodyClass: 'text-center'},
    { header: "순번", field: "sort_ord", type: 'text', style: { width : '5%' }},
    { header: "등록일", field: "fmt_reg_dt", style: { width : '12%' }},
    { header: "등록자", field: "reg_user_nm", style: { width : '6%' }},
    { header: "수정일", field: "fmt_upd_dt", style: { width : '12%' }},
    { header: "수정자", field: "upd_user_nm", style: { width : '6%' }},
    { header: "메모", field: "note", type: 'text', style: { width : '13%' }},
  ],
  gridRowData: [],
  originList: [],
  clickIdx: "",
  updateData: [],
  maxDepth: 1,
  updateCheck: false,
  revidList: [],
  firstLoad: true,
  selectRows: [],
  maxRevid: "",
  revSelect: {
    selected: "",
    list: [],
  },
});

const getList = async () => {
  //상품분류체계 List api 호출
  // state.revidList.map((item) => {
  //   let rev_id = item.rev_id.substr(2);
  //   let maxrevIdVal = state.maxRevid.substr(2);
  //   if (rev_id > maxrevIdVal) {
  //     state.maxRevid = item.rev_id;
  //   }
  // });
  let params = {
    rev_id: state.revSelect.selected, // 리비전 ID 필수값
  };
  try {
    setIsLoading(true)
    const res = await prodList(params)
    state.originList = [...res.rtn]
    state.updateCheck = false;
  } catch (err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
};

const addRow = async () => {
  try {
    setIsLoading(true)
    //선택된 행 정보(새로 생성될 자식row에 부모id값 매칭을 위해 필요)
    let newData = [];
    let selectRows = treeTableRef.value.selectRows
    if (selectRows.length > 0) {
      for (let row of selectRows) {
        let sortNum = setSortNumber(row)
        if(sortNum == 0){
          throw new Error("최대 개수를 초과했습니다.")
        }
        if (row) {
          let data = {
            rev_id: state.revSelect.selected,
            up_class_id: row,
            class_nm: "New Row",
            enable_yn: "Y",
            note: "",
            sort_ord : setSortNumber(row),
            ss_user_id: userStore.user.employeeId,
          };
          newData.push(data);
        }
      }
    } else {
      let sortNum = setSortNumber()
      if(sortNum == 0){
        throw new Error("최대 개수를 초과했습니다.")
      }
      let data = {
        rev_id: state.revSelect.selected,
        up_class_id: "",
        class_nm: "New Row",
        enable_yn: "Y",
        note: "",
        sort_ord : setSortNumber(),
        ss_user_id: userStore.user.employeeId,
      };
      newData.push(data);
    }
    for (const param of newData) {
      await prodEdit(param);
    }

    alert(`추가 완료했습니다.`)
  } catch (e) {
    console.log(e);
    alert("추가에 실패했습니다.");
  } finally {
    await getList();
    setIsLoading(false)
  }
};


const deleteRow = async () => {
 

  try {
    setIsLoading(true)

    let msg = "정말 삭제하시겠습니까?";
    if (state.updateCheck) {
      msg = "저장하지 않은 데이터는 초기화됩니다. 정말 삭제하시겠습니까?";
    }

    let successCnt = 0;
    let selectRows = treeTableRef.value.selectRows
    
    if (confirm(msg)) {
      for (let row of selectRows) {
        let param = {
          rev_id: state.revSelect.selected,
          class_id: row,
        };
        await prodDelete(param)
        await setSortNumberInDelete(row)
        successCnt += 1;
      }
      alert(
        "총 " +
        Object.keys(selectRows).length +
        "건 중에 " +
        successCnt +
        "건을 성공했습니다."
      );
    }
  } catch (e) {
    console.log(e);
    if (e && e.response && e.response.data?.code == "0004") {
      alert(e.response.data.ex_message);
    }
    alert("삭제에 실패했습니다.");
    
  } finally {   
    treeTableRef.value.selectRows = []
    setIsLoading(false)
    getList();
  }
};

//그리드 셀 값 변경시
// const changeRow = () => {
//   state.updateCheck = true;
// };

//이전버튼 클릭
const goBack = () => {
  if (state.updateCheck) {
    let msg = "저장되지 않은 데이터가 있습니다.뒤로 가시겠습니까?";
    if (confirm(msg)) {
      routerCmn.goBack();
    }
  } else {
    routerCmn.goBack();
  }
};

//수정 , 등록완료 클릭 실행 함수
const updateProd = async () => {
  //체크된 row 가져오기

  let msg = "등록하시겠습니까?";
  let successCnt = 0;
  let selectRows = treeTableRef.value.selectRows
  //선택한 값(키값)으로 리스트에서 row 정보 추출
  let selectRowData = state.originList.filter((item) => {
    for (let i of selectRows) {
      if (i == item.class_id) {
        return item;
      }
    }
  });

  try {
    setIsLoading(true)
    if (confirm(msg)) {
      for (let param of selectRowData) {
        await prodEdit(param)
        successCnt += 1;
      }
    }
    alert(
      "총 " +
      selectRowData.length +
      "건 중에 " +
      successCnt +
      "건을 성공했습니다."
    );
  } catch (e) {
    console.log(e);
    alert(
      "총 " +
      selectRowData.length +
      "건 중에 " +
      successCnt +
      "건을 성공했습니다."
    );
  } finally {
    treeTableRef.value.selectRows = []    
    setIsLoading(false)
    getList();
  }

};

async function save(){
  try{
    setIsLoading(true)
    if(confirm('버전업과 동시에 저장됩니다. 저장하시겠습니까?')){
      let params = {
        start_dt : common.dateFormat(new Date()),
        prodClassListVo : []
      }

      params.prodClassListVo = state.originList.map((item)=>{
        let newObj = {
          up_class_id : item.up_class_id,
          class_id : item.class_id,
          class_nm : item.class_nm,
          enable_yn : item.enable_yn,
          note : item.note,
          sort_ord : item.sort_ord
        }
        return newObj
      })
      const res = await prodRevClassInst(params)
      if(res.rtn) alert('버전업에 성공했습니다.')
    }
  }catch(e){
    alert('저장에 실패했습니다.')
    console.log(e)
  }finally{
    setIsLoading(false)
  }
}

//리비전 목록 가져오기
const getRevList = async () => {
  try {
    setIsLoading(true)
    const res = await getProdRevIdList()
    state.revidList = res.rtn;
    state.revSelect.selected = res.rtn[0].rev_id;
  } catch (err) {
    console.error(err)
    alert('리비전 정보를 불러오는데 실패했습니다.')
  } finally {
    setIsLoading(false)
  }
};

//셀 수정 완료시
const onCellEditComplete = (slotProps) => {
  state.originList = state.originList.map((item) => {
    if (item.class_id === slotProps.node.key) {
      item.editCell = new Object()
      item[slotProps.column.key] = slotProps.node.data[slotProps.column.key]
      let checkExist = treeTableRef.value.selectRows.filter(treeItem => treeItem === item.class_id)
      if (checkExist.length === 0) {
        treeTableRef.value.selectRows.push(item.class_id)
      }
    }

    return item
  })
};


const editCell = (obj) => {
  state.originList = state.originList.map((item) => {
    if (item.class_id === obj.key) {
      item.editCell = new Object()
      item.editCell[obj.col] = true

    }
    return item
  })
}

// 추가시 순번 설정
const setSortNumber = (row) => {
  try{
    let number = 0;
    let count = 0
    if(row){
      const selectedRow = state.originList.find(item => item.class_id === row);
      number += Number(selectedRow.sort_ord);
      if(row.length == 4){      
        state.originList.forEach(item => {
          if (item.up_class_id === row) {
            count ++
          }
        });
        number = 10 + number + count * 10
      }else{
        state.originList.forEach(item => {
          if (item.up_class_id === row) {
            count ++
          }
        });
        number = number + count + 1
      }
      if(count > 8){
        alert('최대 개수를 초과했습니다.')    
        return 0
      }
    }else{
      state.originList.forEach(item => {
          if (item.class_id.length === 4) {
            count ++
          }
      });
      number = number + count * 100 + 100
      if(count > 8){  
        alert('최대 개수를 초과했습니다.')      
        return 0
      }
    }
    return number
  }catch (err){
    console.log(err)
  }
}

// 삭제시 순번 설정
const setSortNumberInDelete = async (row) => {
  try {
    if (!row) {
      alert('삭제할 항목이 없습니다.');
      return;
    }

    // 삭제하려는 항목 찾기
    const selectedRow = state.originList.find(item => item.class_id === row)

    const sameGroupItems = state.originList
      .filter(item => item.up_class_id === selectedRow.up_class_id)
      .sort((a, b) => a.sort_ord - b.sort_ord)

    const index = sameGroupItems.findIndex(item => item.class_id === row)

    if (index !== -1) {
      state.originList = state.originList.filter(item => item.class_id !== row)
      const updatedItems = [];

      for (let i = index + 1; i < sameGroupItems.length; i++) {
        if (sameGroupItems[i].class_id.length === 4) {
          sameGroupItems[i].sort_ord -= 100;
        } else if (sameGroupItems[i].class_id.length === 8) {
          sameGroupItems[i].sort_ord -= 10;
        } else {
          sameGroupItems[i].sort_ord -= 1;
        }
        updatedItems.push(sameGroupItems[i]);
      }

      // DB에 저장
      for (const item of updatedItems) {
        await prodEdit(item);
      }
    } else {
      alert('해당 항목을 찾을 수 없습니다.');
    }

  } catch (err) {
    console.error(err);
  }
};

</script>
